module.exports = __webpack_public_path__ + "static/img/手机.c8c0e16b.svg";